import { CountryCodes } from '@clearbanc/data-common-types';

export const COUNTRY_CODES = CountryCodes;

export const SUPPORTED_SELF_SERVE_COUNTRY_CODES = [
  COUNTRY_CODES.CA, // Canada
  COUNTRY_CODES.US, // United States
  COUNTRY_CODES.GB, // United Kingdom
  COUNTRY_CODES.AU, // Australia
  COUNTRY_CODES.IE, // Ireland
  COUNTRY_CODES.FI, // Finland
  COUNTRY_CODES.BE, // Belgium
  COUNTRY_CODES.DE, // Germany
];
